import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { GenericError } from '@cian/peperrors/shared';

import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { selectPuids } from 'shared/selectors/adfox';
import { useApplicationContext } from 'shared/utils/applicationContext';

const Adfox = connect(props => <AdFoxTemplates deviceType="desktop" {...props} />);

export const AdfoxPixelContainer: FC = () => {
  const { logger } = useApplicationContext();
  const puids = useSelector(selectPuids);

  if (!puids) {
    return null;
  }

  const onStubHandle = (): void => {
    logger.error(
      new GenericError({
        details: { developerId: puids.puid39 },
        domain: 'AdfoxPixel',
        message: 'adfoxStub',
        type: 'Adfox',
      }),
    );
  };

  const onErrorHandle = (event: { type: string }): void => {
    logger.error(
      new GenericError({
        details: { developerId: puids.puid39 },
        domain: 'AdfoxPixel',
        message: event.type,
        type: 'Adfox',
      }),
    );
  };

  return (
    <Adfox
      height={1}
      params={{ p1: 'cyrbe', p2: 'frfe', ...puids }}
      width="1"
      onError={onErrorHandle}
      onStub={onStubHandle}
    />
  );
};
